module.exports = {
      id: "icon-current-location-dark-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-current-location-dark",
      toString: function () {
        return this.url;
      }
    }